export const ADMIN_LAYOUT = 'AdminLayout';

export const AdminRouter = [
    {
      path: '/administrator',
      name: 'IndexAdmin',
      component: () => import('../views/Admin/Index'),
      meta: { layout: ADMIN_LAYOUT }
    },
    {
      path: '/administrator/preferences',
      name: 'AdminPreferences',
      component: () => import('../views/Admin/Preferences/Index'),
      meta: { layout: ADMIN_LAYOUT }
    },
    {
      path: '/administrator/events/:event_id/category/:category_id/file-manager',
      name: 'FileManager',
      component: () => import('../views/Admin/Events/FileManager'),
      meta: { layout: ADMIN_LAYOUT }
    }
];
